import { WistiaProjectsEnum } from 'src/app/shared/enums/wistia.enum';
import { InvestmentStrategyModel, ModelMinimumEnum, MoneyManagerEnum, RiskToleranceEnum, TagEnum, LogoEnum, InvestmentResourceModel, FeeTierEnum } from '../models/investments.models';

export const InvestmentStrategies: InvestmentStrategyModel[] = [
  {
    Id: '1',
    Name: 'Alphastar PRME Global Equity',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '2',
    Name: 'Alphastar PRME International Equity',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '3',
    Name: 'Alphastar PRME US Equity',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '6',
    Name: 'Alphastar PRME Patriot',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '7',
    Name: 'Alphastar Primary Equity',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveHundred,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '8',
    Name: 'Alphastar PRME TWIN Enhanced 50',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags: [TagEnum.Growth, TagEnum.TaxEfficient],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '9',
    Name: 'Inspire Aggressive',
    LogoUrl: LogoEnum.Inspire,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Inspire,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '10',
    Name: 'Inspire Equity',
    LogoUrl: LogoEnum.Inspire,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Inspire,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '11',
    Name: 'Russell Inv Active-Passive Equity Growth Model',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth],
    InvestmentLinks: [{
      Title: 'Russell Active-Passive Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/hybrid-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '12',
    Name: 'Russell Inv Tax-Managed Equity Growth Model (Class s)',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.TaxEfficient],
    InvestmentLinks: [{
      Title: 'Russell Tax-Managed Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/tax-managed-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '13',
    Name: 'Vanguard CRSP 100% Equity Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '14',
    Name: 'Alphastar PRME Dynamic',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '15',
    Name: 'Alphastar PRME Opportunity',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '17',
    Name: 'Alphastar Primary Dynamic',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveHundred,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '18',
    Name: 'Russell Inv Active-Passive Growth Model',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth],
    InvestmentLinks: [{
      Title: 'Russell Active-Passive Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/hybrid-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '19',
    Name: 'Russell Inv Tax-Managed Growth Model (Class s)',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.TaxEfficient],
    InvestmentLinks: [{
      Title: 'Russell Tax-Managed Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/tax-managed-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '20',
    Name: 'Vanguard CRSP 80% Equity/ 20% Fixed Income Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '21',
    Name: 'Alphastar PRME Balanced',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '22',
    Name: 'Alphastar PRME Enhanced Income',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '23',
    Name: 'Alphastar PRME Fundamental',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '24',
    Name: 'Alphastar Primary Balanced',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveHundred,
    Tags: [TagEnum.Growth, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '25',
    Name: 'Betashield Global Equity',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.RiskMitigation],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '26',
    Name: 'Betashield International Equity',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.RiskMitigation],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '27',
    Name: 'Betashield Opportunity',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.RiskMitigation],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '28',
    Name: 'Betashield US Equity',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.RiskMitigation],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '29',
    Name: 'Inspire Moderate',
    LogoUrl: LogoEnum.Inspire,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Inspire,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '30',
    Name: 'Russell Inv Active-Passive Balanced Model',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Russell Active-Passive Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/hybrid-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '31',
    Name: 'Russell Inv Tax-Managed Balanced Model (Class s)',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.TaxEfficient],
    InvestmentLinks: [{
      Title: 'Russell Tax-Managed Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/tax-managed-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '32',
    Name: 'Vanguard CRSP 60% Equity/ 40% Fixed Income Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '33',
    Name: 'Alphastar PRME Guardian',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Preservation],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '34',
    Name: 'Alphastar Primary Guardian',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveHundred,
    Tags: [TagEnum.Preservation],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '35',
    Name: 'Betashield Fundamental',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.RiskMitigation],
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '36',
    Name: 'Bond Ladder - High Yield',
    LogoUrl: LogoEnum.Invesco,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Invesco,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Income],
    Description: 'Our Bond Ladder models have a fixed time horizon of 5 years and are comprised of 5 equally-weighted bond ETFs, each with a target maturity of 1 to 5 years.',
    InvestmentLinks: [{
      Title: 'Invesco Resources',
      Link: 'https://www.invesco.com/bulletshares/tools/bond-ladder',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '37',
    Name: 'Inspire Conservative',
    LogoUrl: LogoEnum.Inspire,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Inspire,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Preservation],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '38',
    Name: 'Russell Inv Active-Passive Moderate Model',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Russell Active-Passive Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/hybrid-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '39',
    Name: 'Vanguard CRSP 40% Equity/ 60% Fixed Income Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Growth, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '40',
    Name: 'Alphastar PRME Select Reserves',
    LogoUrl: LogoEnum.AcmPrme,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Preservation, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '41',
    Name: 'Alphastar Primary Assurance',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveHundred,
    Tags: [TagEnum.Preservation, TagEnum.Income],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '42',
    Name: 'Bond Ladder - Investment Grade',
    LogoUrl: LogoEnum.Invesco,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Invesco,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Income],
    Description: 'Our Bond Ladder models have a fixed time horizon of 5 years and are comprised of 5 equally-weighted bond ETFs, each with a target maturity of 1 to 5 years.',
    InvestmentLinks: [{
      Title: 'Invesco Resources',
      Link: 'https://www.invesco.com/bulletshares/tools/bond-ladder',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '43',
    Name: 'Bond Ladder - Municipal',
    LogoUrl: LogoEnum.Invesco,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Invesco,
    ModelMinimum: ModelMinimumEnum.FiveThousand,
    Tags: [TagEnum.Income, TagEnum.TaxEfficient],
    Description: 'Our Bond Ladder models have a fixed time horizon of 5 years and are comprised of 5 equally-weighted bond ETFs, each with a target maturity of 1 to 5 years.',
    InvestmentLinks: [{
      Title: 'Invesco Resources',
      Link: 'https://www.invesco.com/bulletshares/tools/bond-ladder',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '44',
    Name: 'Russell Inv Active-Passive Conservative Model',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Preservation, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Russell Active-Passive Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/hybrid-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '45',
    Name: 'Russell Inv Tax-Managed Conservative Model (Class s)',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.TaxEfficient, TagEnum.Preservation, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Russell Tax-Managed Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/tax-managed-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '46',
    Name: 'Russell Inv Tax-Managed Moderate Model (Class s)',
    LogoUrl: LogoEnum.Russell,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Russell,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.TaxEfficient],
    InvestmentLinks: [{
      Title: 'Russell Tax-Managed Resources',
      Link: 'https://russellinvestments.com/us/fund-center/model-portfolios/tax-managed-model-strategies',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '47',
    Name: 'Vanguard CRSP 100% Fixed Income Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Preservation, TagEnum.Income],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '48',
    Name: 'Vanguard CRSP 20% Equity/ 80% Fixed Income Portfolio',
    LogoUrl: LogoEnum.Vanguard,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Vanguard,
    ModelMinimum: ModelMinimumEnum.TenThousand,
    Tags: [TagEnum.Preservation],
    InvestmentLinks: [{
      Title: 'Vanguard CRSP Portfolio Resources',
      Link: 'https://advisors.vanguard.com/portfolio-construction-tools/model-portfolios',
    }],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '51',
    Name: 'Retirelink 1',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Conservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Preservation],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '52',
    Name: 'Retirelink 2',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '53',
    Name: 'Retirelink 3',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FifteenThousand,
    Tags: [TagEnum.Growth],
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '54',
    Name: 'Alphastar Growth Stock',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '55',
    Name: 'Alphastar Dividend Stock',
    LogoUrl: LogoEnum.Alphastar,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.TwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.Income, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '56',
    Name: 'TWIN Enhanced-Tax SMA',
    LogoUrl: LogoEnum.Twin,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Twin,
    ModelMinimum: ModelMinimumEnum.TwoHundredFiftyThousand,
    Tags: [TagEnum.Growth, TagEnum.TaxEfficient, TagEnum.SMA],
    Description: 'This strategy cannot be commingled in the same account as other strategies – a separate account is required.',
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '57',
    Name: 'Van Hulzen Covered Call SMA',
    LogoUrl: LogoEnum.VanHulzen,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.VanHulzen,
    ModelMinimum: ModelMinimumEnum.TwoHundredFiftyThousand,
    Tags: [TagEnum.Growth, TagEnum.Income, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '58',
    Name: 'Parametric Corporate Bond Ladder SMA',
    LogoUrl: LogoEnum.Parametric,
    MoneyManager: MoneyManagerEnum.Parametric,
    RiskTolerance: RiskToleranceEnum.Conservative,
    ModelMinimum: ModelMinimumEnum.OneHundredTwentyFiveThousand,
    Tags: [TagEnum.Income, TagEnum.Preservation, TagEnum.RiskMitigation, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '59',
    Name: 'Parametric Municipal Bond SMA',
    LogoUrl: LogoEnum.Parametric,
    MoneyManager: MoneyManagerEnum.Parametric,
    RiskTolerance: RiskToleranceEnum.Conservative,
    ModelMinimum: ModelMinimumEnum.TwoHundredFiftyThousand,
    Tags: [TagEnum.Income, TagEnum.Preservation, TagEnum.RiskMitigation, TagEnum.TaxEfficient, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '60',
    Name: 'Parametric Treasury Bond Ladder SMA',
    LogoUrl: LogoEnum.Parametric,
    MoneyManager: MoneyManagerEnum.Parametric,
    RiskTolerance: RiskToleranceEnum.Conservative,
    ModelMinimum: ModelMinimumEnum.OneHundredTwentyFiveThousand,
    Tags: [TagEnum.Growth, TagEnum.Income, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '61',
    Name: 'Nuveen-Brooklyn Tax-Advantaged Long/Short SMA',
    LogoUrl: LogoEnum.NuveenBrooklyn,
    RiskTolerance: RiskToleranceEnum.Variable,
    MoneyManager: MoneyManagerEnum.NuveenBrooklyn,
    ModelMinimum: ModelMinimumEnum.TenMillion,
    Tags:  [TagEnum.Growth, TagEnum.Income, TagEnum.SMA],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '62',
    Name: 'Alphastar SLCT Growth',
    LogoUrl: LogoEnum.AcmSlct,
    RiskTolerance: RiskToleranceEnum.Aggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.Growth],
    IsSMA: false,
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '63',
    Name: 'Alphastar SLCT Income',
    LogoUrl: LogoEnum.AcmSlct,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.Preservation, TagEnum.Income],
    IsSMA: false,
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '64',
    Name: 'Alphastar SLCT Tax-Aware Income',
    LogoUrl: LogoEnum.AcmSlct,
    RiskTolerance: RiskToleranceEnum.Moderate,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.Preservation, TagEnum.Income],
    IsSMA: false,
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '65',
    Name: 'Alphastar SLCT Balanced',
    LogoUrl: LogoEnum.AcmSlct,
    RiskTolerance: RiskToleranceEnum.ModeratelyConservative,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.Growth, TagEnum.Income],
    IsSMA: false,
    FeeTier: FeeTierEnum.One,
  },
  {
    Id: '66',
    Name: 'Alphastar Structured Growth SMA',
    LogoUrl: LogoEnum.Sage,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Sage,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.SMA, TagEnum.Growth],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '67',
    Name: 'Alphastar Structured Income SMA',
    LogoUrl: LogoEnum.Sage,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Sage,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.SMA, TagEnum.Income],
    IsSMA: true,
    FeeTier: FeeTierEnum.Two,
  },
  {
    Id: '68',
    Name: 'Alphastar SLCT Premium Income',
    LogoUrl: LogoEnum.AcmSlct,
    RiskTolerance: RiskToleranceEnum.ModeratelyAggressive,
    MoneyManager: MoneyManagerEnum.Alphastar,
    ModelMinimum: ModelMinimumEnum.FiftyThousand,
    Tags:  [TagEnum.Income],
    IsSMA: false,
    FeeTier: FeeTierEnum.One,
  },
];

export const InvestmentResources: InvestmentResourceModel[] = [
  {
    Id: '18',
    Name: 'Investment Resources',
    LogoUrls: [ LogoEnum.Alphastar ],
    Description: '',
    AdditionalDescription: '',
    WistiaProject: WistiaProjectsEnum.ResourceCenter
  },
  {
    Id: '101',
    Name: 'Structured Notes',
    LogoUrls: [ LogoEnum.Luma, LogoEnum.Alphastar ],
    Description: 'Structured notes allow investors to commit capital for a specific time period in exchange for potentially high returns, high income, or capital preservation during times of market volatility.',
    AdditionalDescription: 'Contact your sales team to learn more about structured notes through our partner LUMA.',
    WistiaProject: WistiaProjectsEnum.Investments
  },
  {
    Id: '102',
    Name: 'Fee-Based Insurance Products',
    LogoUrls: [ LogoEnum.Alphastar ],
    Description: 'Insurance products such as fixed-index annuities (FIA) and registered index-linked annuities (RILA) and others can limit exposure to downside risk while providing opportunity for growth and income.',
    AdditionalDescription: 'Contact your sales team to learn more about how Alphastar can help with fee-based insurance.',
    WistiaProject: WistiaProjectsEnum.Investments
  },
  {
    Id: '103',
    Name: 'DST',
    LogoUrls: [ LogoEnum.Madrona ],
    Description: 'A Delaware Statutory Trust allows accredited investors to exchange a single property for a diversified portfolio of real estate holdings, benefiting from tax efficiencies.',
    AdditionalDescription: 'Contact your sales team to learn more about DSTs through our partner Madrona Financial Services.',
    WistiaProject: WistiaProjectsEnum.Investments
  },
  {
    Id: '104',
    Name: 'Alternative Investments',
    LogoUrls: [ LogoEnum.AlternativeInvestment ],
    Description: 'Alternative investments include hedge funds, private equity, private credit, and other asset classes targeted to high-net-worth clients. They can offer potentially high returns, high income, low volatility and/or low correlation to traditional asset classes.',
    AdditionalDescription: 'For more information about alternative investments, please speak to the Alphastar team about accessing the CAIS platform.',
    WistiaProject: WistiaProjectsEnum.Investments
  },
];